import React, { useState } from "react";
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupIcon from '@mui/icons-material/Group';
import DeleteIcon from '@mui/icons-material/Delete';
import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined';

interface ManageBulkUsersMenuProps {
    toggleDrawer: (open: boolean, state: "create" | string) => () => void;
    disableActionButtons: boolean;
}

export default function ManageBulkUsersMenu({ toggleDrawer, disableActionButtons }: ManageBulkUsersMenuProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                variant="contained"
                onClick={handleClick}
                startIcon={<SettingsIcon />}
                sx={{
                    backgroundColor: "#0D3B66",
                    "&:hover": { backgroundColor: "#0B3257" },
                    textTransform: "none",
                    mr: 2
                }}
                disabled={disableActionButtons}
            >
                Manage Bulk Users
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{
                    "& .MuiList-root": {
                        backgroundColor: "#041B31",
                        color: "#fff",
                    },
                    "& .MuiMenuItem-root": {
                        "&:hover": {
                            backgroundColor: "#06294F"
                        }
                    }
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <MenuItem onClick={() => {
                    handleClose();
                    toggleDrawer(true, "create-bulk-users")();
                }}>
                    <ListItemIcon>
                        <PlaylistAddOutlinedIcon sx={{ color: "#fff" }}/>
                    </ListItemIcon>
                    <ListItemText primary="Add Bulk Users" />
                </MenuItem>

                <MenuItem onClick={() => {
                    handleClose();
                    toggleDrawer(true, "bulk-activate-deactivate-users")();
                }}>
                    <ListItemIcon>
                        <GroupIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Set Active/Inactive" />
                </MenuItem>

                <MenuItem onClick={() => {
                    handleClose();
                    toggleDrawer(true, "bulk-delete-users")();
                }}>
                    <ListItemIcon>
                        <DeleteIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Delete Bulk Users" />
                </MenuItem>

                <MenuItem onClick={() => {
                    handleClose();
                    toggleDrawer(true, "bulk-transfer-users-term")();
                }}>
                    <ListItemIcon>
                        <MoveUpOutlinedIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Transfer Term" />
                </MenuItem>
            </Menu>
        </>
    );
}
